import EventParticipantsList from "./EventParticipantsList";
export default EventParticipantsList;
